export default "__VITE_ASSET__DwnidnGU__"